import React, { useState } from "react";
import { motion } from "motion/react";
import TeamsTabs from "./components/TeamsTabs";
import TeamsAllUsersTabContent from "./components/TeamsAllUsersTabContent";
import TeamsHierarchyTabContent from "./components/TeamsHierarchyTabContent";
import "./Teams.css";

const Teams = () => {
  const [activeTab, setActiveTab] = useState("all-users");

  return (
    <div className="teams-mainCont">
      <div className="headerCont">
        <div className="titlecont">
          <h3>Teams</h3>
          <p>Manage your teams</p>
        </div>
      </div>

      <motion.div layout>
        <TeamsTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </motion.div>

      <div className="tab-content">
        {activeTab === "all-users" && <TeamsAllUsersTabContent />}
        {activeTab === "hierarchy" && <TeamsHierarchyTabContent />}
      </div>
    </div>
  );
};

export default Teams;
